<app-header>
  <h1 app-overline>Step 3</h1>
  <h2 app-title>Summary</h2>
</app-header>

<app-header>
  <h1 app-title>Pattern Configuration</h1>
</app-header>
<mat-divider></mat-divider>
<div style="padding: 1em 0 1em 0">
  <app-card-pattern-config [pattern]="patternConfig"> </app-card-pattern-config>
</div>

<app-header>
  <h1 app-title>Robot Configurations</h1>
</app-header>
<mat-divider></mat-divider>

<ng-container *ngIf="robotConfigs as rcs">
  <app-slideshow
    [inputArray]="rcs"
    (focusedElement)="displayedRobotConfig = $event"
  >
    <app-card-robot-config [robotConfig]="displayedRobotConfig">
    </app-card-robot-config>
  </app-slideshow>
</ng-container>
